/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection';

export class AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner {
  /**
  * Name of the local secondary index.
  */
  'indexName'?: string | null;
  /**
  * The complete key schema for the local secondary index.
  */
  'keySchema'?: Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>;
  'projection'?: AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection | null;
  /**
  * Total size of the specified index, in bytes.
  */
  'indexSizeBytes'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "indexName",
      "baseName": "indexName",
      "type": "string",
      "format": ""
    },
    {
      "name": "keySchema",
      "baseName": "keySchema",
      "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>",
      "format": ""
    },
    {
      "name": "projection",
      "baseName": "projection",
      "type": "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection",
      "format": ""
    },
    {
      "name": "indexSizeBytes",
      "baseName": "indexSizeBytes",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

